<template>
  <div
    class="animated fadeIn profile-component main-div"
    :class="uniInfo.isDistinguished ? 'distinguished-class' : ''"
  >
    <vLoading v-if="vLoading" />
    <div v-if="!notAllowed">
      <div v-if="pageLoaded">
        <v-row class="pt-1">
          <v-col sm="6" cols="12">
            <div class="pt-1 fs-small">
              <router-link to="/map" class="no-underline">
                <span class="c-primary"> انتخاب استان </span>
              </router-link>
              <v-icon class="left-icon">mdi-chevron-left</v-icon>
              <span @click="goToMap('state')" class="pointer">
                استان {{ uniInfo.state }}
              </span>
              <v-icon class="left-icon">mdi-chevron-left</v-icon>
              <span @click="goToMap('university')" class="pointer">
                دانشگاه‌ها{{ uniInfo.isDistinguished ? "ی ممتاز" : "" }}
              </span>
              <v-icon class="left-icon">mdi-chevron-left</v-icon>
              <span class="font-weight-bold"> {{ uniInfo.name }} </span>
            </div>
          </v-col>
          <v-col class="text-left" sm="6" cols="12">
            <v-btn
              @click="goToMap('state')"
              class="bc-primary text-white no-underline"
              :class="uniInfo.isDistinguished ? 'toMap-btn' : ''"
              ><span class="c-light">بازگشت به نقشه</span></v-btn
            >
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card uni-card">
              <v-row class="uni-header">
                <v-col cols="12" class="d-flex flex-column flex-sm-row">
                  <div class="view-imageBox">
                    <img
                      :src="
                        uniInfo.avatar
                          ? uniInfo.avatar
                          : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                      "
                    />
                  </div>
                  <div class="description-box px-5">
                    <div class="d-flex">
                      <img
                        v-if="uniInfo.isDistinguished"
                        class="star-icon me-2"
                        src="/icon-star.png"
                      />
                      <h5 class="mt-3 c-dark fs-xxlarge">
                        {{ uniInfo.name }}
                      </h5>
                    </div>
                    <p
                      v-if="uniInfo.description"
                      class="c-grey fs-medium text-justify ps-2"
                    >
                      {{
                        uniInfo.description.length > 180
                          ? uniInfo.description.slice(0, 180) + "..."
                          : uniInfo.description
                      }}
                    </p>
                    <p v-else class="c-grey fs-small">
                      توضیحی برای دانشگاه ثبت نشده است.
                    </p>
                  </div>
                </v-col>
              </v-row>
              <div v-if="uniInfo.description.length > 220" class="text-left">
                <v-btn
                  class="seeMore-btn"
                  @click="openSeeMoreModal('description')"
                  text
                >
                  <span class="c-primary">مشاهده بیشتر</span>
                </v-btn>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس دانشگاه</h5>
              <div class="pt-2 c-grey">
                <v-icon class="pe-2">$Location</v-icon>
                <span class="fs-medium">
                  نشانی دانشگاه:
                  {{
                    uniInfo.state +
                    ", " +
                    uniInfo.city +
                    (uniInfo.city ? ", " : "")
                  }}{{ uniInfo.address ? uniInfo.address : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2">$Phone</v-icon>
                <span class="fs-medium">
                  تلفن‌های تماس روابط عمومی:
                  {{ uniInfo.tel ? uniInfo.tel : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2">$Email</v-icon>
                <span class="fs-medium">
                  کدپستی: {{ uniInfo.postalCode ? uniInfo.postalCode : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2">$Url</v-icon>
                <span class="fs-medium" v-if="uniInfo.website">
                  آدرس‌‌ تارنما:
                  <a :href="checkWebsite()" target="_blank">{{
                    uniInfo.website
                  }}</a>
                </span>
                <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <v-row class="pe-2 ps-2">
                <v-col class="center-col">
                  <h5 class="fs-xxlarge">
                    اعضای هیئت علمی تعریف شده در سامانه
                  </h5>

                  <v-spacer></v-spacer>
                  <h6 class="fs-large">
                    {{
                      uniInfo.scienceCommitteeNo
                        ? uniInfo.scienceCommitteeNo
                        : "0"
                    }}
                    نفر
                  </h6>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  uniInfo.scienceCommittee && uniInfo.scienceCommittee.length
                "
              >
                <v-col
                  cols="4"
                  sm="4"
                  md="3"
                  lg="3"
                  xl="3"
                  v-for="(professor, index) in uniInfo.scienceCommittee.slice(
                    0,
                    this.scienceCommitteeSize
                  )"
                  :key="index"
                  class="text-center"
                >
                  <img
                    class="professor-img w-100 mb-3"
                    :src="
                      professor.avatar
                        ? professor.avatar
                        : 'https://bigbangram.com/theme/img/noavatar.png'
                    "
                  />
                  <h6 class="fs-medium c-dark">{{ professor.name }}</h6>
                  <span class="c-grey fs-small">{{ professor.degree }}</span>
                </v-col>
              </v-row>
              <v-row v-else>
                <div class="text-center mt-10 w-100">
                  <hr />
                  <span class="fs-small c-grey">عضوی به ثبت نرسیده است.</span>
                  <hr />
                </div>
              </v-row>
              <v-row class="justify-content-center mt-5">
                <v-btn
                  v-if="uniInfo.scienceCommittee.length"
                  :to="'/universityFaculty/' + universityId"
                  class="see-btn text-primary font-weight-bold"
                >
                  <span> مشاهده همه اعضا </span>
                  <v-icon large> mdi-chevron-left </v-icon>
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="stretch-col">
            <v-card class="common-card first-card">
              <v-row>
                <v-col class="center-col">
                  <h5 class="mt-1 fs-xlarge">دانشجویان مرتبط با زیست فناوری</h5>
                  <v-spacer></v-spacer>
                  <h6 class="mt-1 fs-large">
                    {{
                      uniInfo.bioStudentCounts ? uniInfo.bioStudentCounts : "0"
                    }}
                    نفر
                  </h6>
                </v-col>
              </v-row>
            </v-card>
            <!-- <v-card class="common-card second-card mt-2">
              <v-row>
                <v-col class="center-col">
                  <h5 class="mb-4 fs-xxlarge">
                    {{ computedMehvarCardTitle }}
                  </h5>
                  <v-spacer></v-spacer>
                  <h6 class="mt-1 fs-large">
                    {{
                      uniInfo.mehvars.length +
                      uniInfo.otherMehvars.filter((x) => x.acceleratorId)
                        .length +
                      " مورد"
                    }}
                  </h6>
                </v-col>
              </v-row>

              <div class="text-center mt-6">
                <hr />
                <span class="fs-small c-grey"
                  >جهت مشاهده محورها، تکمیل پروفایل دانشگاه الزامیست.</span
                >
                <hr />
              </div>
            </v-card> -->
            <!-- <div v-else>
                <div v-if="uniInfo.mehvars.length >= 3" class="ms-5">
                  <ul class="mb-3">
                    <li
                      v-for="(mehvar, index) in uniInfo.mehvars.slice(0, 3)"
                      :key="index"
                      class="pb-3"
                    >
                      <span class="fs-medium c-grey">
                        <v-icon>mdi-circle-medium</v-icon>
                        {{
                          mehvar.name.length > 70
                            ? mehvar.name.slice(0, 70) + "..."
                            : mehvar.name
                        }}
                      </span>
                    </li>
                  </ul>

                  <div class="text-left">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('mehvar')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div
                  v-else-if="
                    uniInfo.mehvars.length < 3 && uniInfo.mehvars.length != 0
                  "
                  class="ms-5"
                >
                  <ul>
                    <div
                      v-for="(mehvar, index) in uniInfo.mehvars"
                      :key="index"
                      class="mb-3"
                    >
                      <li class="fs-medium c-grey">
                        <v-icon>mdi-circle-medium</v-icon>
                        {{
                          mehvar.name.length > 70
                            ? mehvar.name.slice(0, 70) + "..."
                            : mehvar.name
                        }}
                      </li>
                    </div>
                  </ul>

                  <div class="text-left pt-3">
                    <v-btn
                      v-if="
                        showMehvarMoreBtn ||
                        uniInfo.otherMehvars.filter((x) => x.acceleratorId)
                          .length
                      "
                      class="seeMore-btn"
                      @click="
                        openSeeMoreModal('mehvar');
                        mehvarType = 'mehvars';
                      "
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div
                  v-else-if="
                    !uniInfo.mehvars.length &&
                    uniInfo.otherMehvars.filter((x) => x.acceleratorId).length
                  "
                  class="ms-5"
                >
                  <ul>
                    <div
                      v-for="(mehvar, index) in uniInfo.otherMehvars.filter(
                        (x) => x.acceleratorId
                      )"
                      :key="index"
                      class="mb-3"
                    >
                      <li class="fs-medium c-grey">
                        <v-icon>mdi-circle-medium</v-icon>
                        {{
                          mehvar.name.length > 70
                            ? mehvar.name.slice(0, 70) + "..."
                            : mehvar.name
                        }}
                        <span
                          v-if="mehvar.acceleratorId"
                          @click="goToAccelerator(mehvar.acceleratorId)"
                          class="pointer cyan--text text--lighten-1"
                        >
                          {{
                            "( نام‌ شتاب‌دهنده: " +
                            mehvar.acceleratorName +
                            " )"
                          }}
                        </span>
                      </li>
                    </div>
                  </ul>

                  <div class="text-left pt-3">
                    <v-btn
                      v-if="showMehvarMoreBtn"
                      class="seeMore-btn"
                      @click="
                        openSeeMoreModal('mehvar');
                        mehvarType = 'otherMehvars';
                      "
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </div> -->

            <v-card class="common-card second-card mt-2">
              <v-row>
                <v-col class="center-col">
                  <h5 class="mt-1 fs-xlarge">موضوعات طرح تقسیم کار ملی</h5>
                  <v-spacer></v-spacer>
                  <h6 class="mt-1 fs-large">
                    {{ uniInfo.cats.length }}
                    مورد
                  </h6>
                </v-col>
              </v-row>
              <div v-if="uniInfo.cats.length">
                <ul class="mb-3 mt-1" v-if="uniInfo.cats.length">
                  <li
                    v-for="(mehvar, index) in uniInfo.cats.slice(0, 3)"
                    :key="index"
                    class="pb-3"
                  >
                    <span class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{ mehvar.name }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="text-center mt-6" v-else>
                <hr />
                <span class="fs-small c-grey"
                  >جهت مشاهده محورها، تکمیل پروفایل دانشگاه الزامیست.</span
                >
                <hr />
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="uniInfo.chartHasData">
          <v-col>
            <v-card class="common-card w-100">
              <v-card-title>
                <h5 class="fs-xxlarge">آمار حمایت‌ ها</h5>
              </v-card-title>
              <Chart
                name="barChart"
                :chartdata="uniInfo.requests"
                :options="computedOptionsBar"
                type="bar"
                :height="130"
                v-if="loaded"
              >
              </Chart>
            </v-card>
          </v-col>
        </v-row>
        <div v-if="uniInfo.isDistinguished">
          <v-row class="mb-2">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
              v-if="uniInfo.uniProjects"
            >
              <v-card class="common-card card-height mt-3">
                <v-row>
                  <v-col>
                    <h5 class="mb-4 fs-xxlarge">پروژه‌های انجام شده دانشگاه</h5>
                  </v-col>
                </v-row>
                <div v-if="!uniInfo.uniProjects" class="text-center my-12">
                  <hr />
                  <span class="fs-small c-grey"
                    >توضیحی برای این قسمت ثبت نشده‌ است.</span
                  >
                  <hr />
                </div>
                <div v-else>
                  <!-- inja -->
                  <p
                    class="c-grey fs-medium text-justify"
                    v-html="
                      uniInfo.uniProjects.length > 350
                        ? uniInfo.uniProjects.slice(0, 350) + '...'
                        : uniInfo.uniProjects
                    "
                  ></p>

                  <div
                    v-if="uniInfo.uniProjects.length > 350"
                    class="text-left mt-8"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('uniProjects')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </v-card></v-col
            >
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
              v-if="uniInfo.uniGrants"
            >
              <v-card class="common-card card-height mt-3">
                <v-row>
                  <v-col>
                    <h5 class="mb-4 fs-xxlarge">گرنت‌های دریافتی دانشگاه</h5>
                  </v-col>
                </v-row>
                <div v-if="!uniInfo.uniGrants" class="text-center my-12">
                  <hr />
                  <span class="fs-small c-grey"
                    >توضیحی برای این قسمت ثبت نشده‌ است.</span
                  >
                  <hr />
                </div>
                <div v-else>
                  <p
                    class="c-grey fs-medium text-justify"
                    v-html="
                      uniInfo.uniGrants.length > 350
                        ? uniInfo.uniGrants.slice(0, 350) + '...'
                        : uniInfo.uniGrants
                    "
                  ></p>

                  <div
                    v-if="uniInfo.uniGrants.length > 350"
                    class="text-left mt-8"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('uniGrants')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </v-card></v-col
            >
          </v-row>
          <v-row v-if="uniInfo.uniFurtherDescription">
            <v-col>
              <v-card class="common-card">
                <v-row>
                  <v-col>
                    <h5 class="mb-4 fs-xxlarge">توضیحات تکمیلی</h5>
                  </v-col>
                </v-row>
                <div
                  v-if="!uniInfo.uniFurtherDescription"
                  class="text-center my-12"
                >
                  <hr />
                  <span class="fs-small c-grey">توضیحی ثبت نشده‌ است.</span>
                  <hr />
                </div>
                <div v-else>
                  <!-- inja -->
                  <p
                    class="c-grey fs-medium text-justify"
                    v-html="
                      uniInfo.uniFurtherDescription.length > 350
                        ? uniInfo.uniFurtherDescription.slice(0, 350) + '...'
                        : uniInfo.uniFurtherDescription
                    "
                  ></p>

                  <div
                    v-if="uniInfo.uniFurtherDescription.length > 350"
                    class="text-left mt-14"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('uniFurtherDescription')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </v-card></v-col
            >
          </v-row>
        </div>
        <v-row class="mt-4">
          <v-col>
            <v-card class="common-card w-100">
              <v-card-title>
                <h5 class="fs-xxlarge">گالری تصاویر</h5>
              </v-card-title>
              <div v-if="uniInfo.gallery.length">
                <v-row v-if="type != 'mobile'">
                  <v-col
                    class="text-center img-col d-flex"
                    sm="4"
                    md="4"
                    lg="2"
                    xl="2"
                    v-for="(img, index) in uniInfo.gallery"
                    :key="index"
                  >
                    <img :src="img.url" class="gallery-img mb-2" />
                    <span class="fs-medium">{{
                      img.title.length > 20
                        ? img.title.slice(0, 20) + "..."
                        : img.title
                    }}</span>
                  </v-col>
                </v-row>
                <v-row v-if="type == 'mobile'">
                  <v-col>
                    <v-card class="common-card w-100">
                      <v-row class="main-div p-0">
                        <v-carousel
                          v-model="model"
                          hide-delimiters
                          :show-arrows="uniInfo.gallery.length > 1"
                        >
                          <v-carousel-item
                            cycle
                            v-for="(img, index) in uniInfo.gallery"
                            :key="index"
                            :src="img.url"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                            class="slider"
                          >
                          </v-carousel-item>
                        </v-carousel>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-else>
                <div class="text-center mt-3 mb-16">
                  <hr />
                  <h5 class="fs-small c-grey text-center">
                    تصویری برای این دانشگاه به ثبت نرسیده است.
                  </h5>
                  <hr />
                </div>
              </div>
              <v-row class="justify-content-center mt-5">
                <v-btn
                  v-if="uniInfo.gallery.length"
                  :to="'/universityImages/' + universityId"
                  class="see-btn text-primary font-weight-bold"
                >
                  <span> مشاهده همه تصاویر </span>
                  <v-icon large> mdi-chevron-left </v-icon>
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else>
      <v-row class="p-1">
        <v-col sm="6" cols="12"> &nbsp; </v-col>
        <v-col sm="6" cols="12" class="text-left">
          <v-btn to="/map" class="bc-primary text-white no-underline"
            ><span class="c-light">بازگشت به نقشه</span></v-btn
          >
        </v-col>
      </v-row>
      <v-card class="mt-3">
        <v-container>
          <hr />
          <h5 class="text-center">دسترسی به اطلاعات این دانشگاه وجود ندارد</h5>
          <hr />
        </v-container>
      </v-card>
    </div>

    <v-dialog v-model="seeMoreModal" width="700">
      <v-card
        v-if="seeMoreType == 'description'"
        class="modal-card"
        :class="uniInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">{{ uniInfo.name }}</h5>
            </v-col>
            <v-col class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p class="c-grey fs-medium text-justify" style="line-height: 30px">
            {{ uniInfo.description }}
          </p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'mehvar'"
        class="modal-card"
        :class="uniInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">محورهای طرح تقسیم کار ملی</h5>
            </v-col>
            <v-col class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <div class="cats-box">
            <div
              v-for="(mehvar, index) in uniInfo.mehvars"
              :key="index"
              class="mb-5"
            >
              <span class="c-grey fs-medium">
                <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                {{ " " + mehvar.name }}
              </span>
            </div>
          </div>
          <div
            v-if="uniInfo.otherMehvars.filter((x) => x.acceleratorId).length"
          >
            <hr />
            <h5 class="c-dark fs-large mt-6">همکاری با شتاب‌دهنده ها</h5>
            <div class="mehvars-box mt-6">
              <div
                v-for="(mehvar, index) in uniInfo.otherMehvars.filter(
                  (x) => x.acceleratorId
                )"
                :key="index"
                class="mb-5"
              >
                <span class="c-grey fs-medium">
                  <v-icon class="pt-1 c-grey">mdi-circle-medium</v-icon>
                  {{ " " + mehvar.name }}
                </span>
                <span
                  v-if="mehvar.acceleratorId"
                  @click="goToAccelerator(mehvar.acceleratorId)"
                  class="pointer cyan--text text--lighten-1"
                >
                  {{ "( نام‌ شتاب‌دهنده: " + mehvar.acceleratorName + " )" }}
                </span>
              </div>
            </div>
          </div>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'uniProjects'"
        class="modal-card"
        :class="uniInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">
                پروژه‌های انجام شده دانشگاه
              </h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="uniInfo.uniProjects"
          ></p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'uniGrants'"
        class="modal-card"
        :class="uniInfo.isDistinguished ? 'dark-modal' : ''"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">گرنت‌های دریافتی دانشگاه</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="uniInfo.uniGrants"
          ></p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'uniFurtherDescription'"
        class="modal-card dark-modal"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">توضیحات تکمیلی</h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="uniInfo.uniFurtherDescription"
          ></p>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Chart from "/src/components/charts/Chart.vue";

export default {
  components: {
    Chart,
  },
  data() {
    return {
      city: "",
      model: 0,
      uniId: "",
      interval: {},
      busy: true,
      value: 0,
      uniInfo: {},
      list: [],
      loaded: false,
      scienceCommitteeSize: "",
      type: "",
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: true,
            position: "right",

            labels: {
              color: "white",
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            min: 0,

            ticks: {
              stepSize: 1,
              color: "white",
              beginAtZero: true,
              font: {
                family: "iransans",
              },
            },

            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              color: "white",
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      supportsChart: {},
      isBusy: false,
      vLoading: false,
      notAllowed: false,
      seeMoreModal: false,
      universityId: "",
      seeMoreType: "",
      pageLoaded: false,
      mehvarType: "mehvars",
    };
  },
  methods: {
    goToAccelerator(id) {
      let link = "";
      link = "/acceleratorProfile/" + id;
      window.open(link, "_blank");
    },
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    goToMap(to) {
      this.$router.push("/map");
      if (to == "state") {
        localStorage.setItem("state", this.uniInfo.state);
        localStorage.setItem("stateId", this.uniInfo.stateId);
      } else if (to == "university") {
        localStorage.setItem("state", this.uniInfo.state);
        localStorage.setItem("stateId", this.uniInfo.stateId);
        if (this.uniInfo.isDistinguished) {
          localStorage.setItem("item", "disUni");
        } else {
          localStorage.setItem("item", "university");
        }
      }
    },
    getProfileInfo() {
      this.isBusy = true;
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/university/getInfo",
          {
            universityId: this.$route.params.id,
          },
          {}
        )
        .then((res) => {
          if (window.screen.width < 850) {
            this.type = "mobile";
          } else {
            if (document.body.clientWidth < 850) {
              this.type = "mobile";
            } else {
              this.type = "desktop";
            }
          }

          this.uniInfo = res.data;
          this.vLoading = false;
          this.pageLoaded = true;

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.scienceCommitteeSize = 3;
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          } else {
            this.scienceCommitteeSize = 4;
          }
          this.optionsBar.scales.y.ticks.stepSize =
            this.uniInfo.requestDetailsStepSum;

          setTimeout(() => {
            this.loaded = true;
          }, 1000);
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.vLoading = false;
          if (err.response.status == 403) {
            this.notAllowed = true;
          } else {
            console.log(err);
            this.toast(err.response.data, "error");
          }
        });
    },
    checkWebsite() {
      if (
        this.uniInfo.website.indexOf("http://") == 0 ||
        this.uniInfo.website.indexOf("https://") == 0
      ) {
        return this.uniInfo.website;
      } else {
        return "//" + this.uniInfo.website;
      }
    },
  },
  computed: {
    computedMehvarCardTitle() {
      if (!this.uniInfo.otherMehvars.filter((x) => x.acceleratorId).length) {
        return "محورهای طرح تقسیم کار ملی";
      }
      // else if (
      //   this.uniInfo.otherMehvars.filter((x) => x.acceleratorId).length &&
      //   !this.uniInfo.mehvars.length
      // ) {
      //   return "محور‌های همکاری شده با شتاب‌دهنده";
      // }
      else {
        return "محورهای طرح تقسیم کار ملی";
      }
    },
    showMehvarMoreBtn() {
      let temp;
      temp = this.uniInfo[this.mehvarType].filter((x) => x.name.length > 70);
      if (temp.length) {
        return true;
      } else {
        return false;
      }
    },
    computedOptionsBar() {
      if (this.uniInfo.isDistinguished) {
        return {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              rtl: true,
              display: true,
              position: "right",

              labels: {
                color: "white",
                font: {
                  family: "iransans",
                },
                boxWidth: 24,
                boxHeight: 24,
                usePointStyle: true,
                pointStyle: "circle",
              },
            },
            tooltip: {
              titleFont: {
                family: "iransans",
              },
              bodyFont: {
                family: "iransans",
              },
            },
          },

          title: {
            display: true,
            fontSize: 16,
            position: "top",
            text: "",
          },

          scales: {
            y: {
              scaleLabel: {
                display: true,
                labelString: "",
              },
              min: 0,

              ticks: {
                stepSize: 1,
                color: "white",
                beginAtZero: true,
                font: {
                  family: "iransans",
                },
              },

              stacked: true,
            },
            x: {
              stacked: true,
              ticks: {
                color: "white",
                font: {
                  family: "iransans",
                },
              },
            },
          },
        };
      } else {
        return {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              rtl: true,
              display: true,
              position: "right",

              labels: {
                font: {
                  family: "iransans",
                },
                boxWidth: 24,
                boxHeight: 24,
                usePointStyle: true,
                pointStyle: "circle",
              },
            },
            tooltip: {
              titleFont: {
                family: "iransans",
              },
              bodyFont: {
                family: "iransans",
              },
            },
          },

          title: {
            display: true,
            fontSize: 16,
            position: "top",
            text: "",
          },

          scales: {
            y: {
              scaleLabel: {
                display: true,
                labelString: "",
              },
              min: 0,

              ticks: {
                stepSize: 1,
                beginAtZero: true,
                font: {
                  family: "iransans",
                },
              },

              stacked: true,
            },
            x: {
              stacked: true,
              ticks: {
                font: {
                  family: "iransans",
                },
              },
            },
          },
        };
      }
    },
  },
  mounted() {
    this.universityId = this.$route.params.id;
    this.getProfileInfo();
  },
};
</script>
<style lang="scss">
.modal-card {
  .mehvars-box {
    margin: 5px 0;
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
}
</style>
